<template>
	<div class="legal-sts">
		<b-card no-body>
			<b-card-header class="py-2 px-3">
				<h3 class="mb-0">Legal STS</h3>
			</b-card-header>
			<div v-if="tableData.length > 0" class="card-table rounded-bottom">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="legal_sts_loan_statue" label="Facility" min-width="180" width="auto">
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.legal_sts_loan_statue }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="legal_sts_current_outstanding" label="Outstanding (RM)" min-width="200" width="auto">
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.legal_sts_current_outstanding | moneyFormatter }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="legal_sts_current_installment" label="Instalment (RM)" min-width="200" width="auto">
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.legal_sts_current_installment | moneyFormatter }}</p>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else class="bg-light p-3 text-center rounded-bottom">
				<p class="text-xs">No Legal Status recorded</p>
			</div>
		</b-card>
	</div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'

export default {
	name: 'legal-sts',
	props: ['legal_sts'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			tableData: this.legal_sts
		}
	},
}
</script>